











































































































































import { Component, Prop, Vue } from 'vue-property-decorator';

import { DeleteResultModel, TimeEntryViewModel } from '@/services/api/nswag/stapiclient_generated';
import { stTimeEntryApi } from '@/services/st-api';
import UserModule, { UserStore } from '@/store/user-module';
import { StopwatchStore } from '@/store/stopwatch-store';
import { notifyDeletion, notifySuccess } from '@/utlitities/notifications';
import { TimeEntryStore } from '@/store/time-entry-store';
import StarRating from 'vue-star-rating';
import { DateTime } from "luxon";
import StSupBadge from "@/components/basic/StSupBadge.vue";

Component.registerHooks(['beforeRouteUpdate']);

@Component({
  components: { StSupBadge, StarRating },
})
export default class TimeEntry extends Vue {
  @Prop() entry!: TimeEntryViewModel;

  private userStore: UserModule = UserStore;
  stopwatchLoading: boolean = false;
  deleteLoading: boolean = false;

  showDateChanger: boolean = false;

  editTimeEntry() {
    if (this.stopwatchLoading || this.deleteLoading || this.entry.isDisabled) {
      return;
    }

    this.$router.push({ name: 'TimeEntryEdit', params: { id: this.entry.id!.toString() } });
  }

  get selectedUserId(){
    return TimeEntryStore.selectedUserId;
  }

  get useProjectTimeTracking(){
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  get hasProjectTasks() {
    return UserStore.userSettings.hasProjectTasks;
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  getExtraFields(entry: TimeEntryViewModel){
    return entry.timeEntryExtraFields?.filter(x=>!x.hideInDayView) ?? [];
  }

  async copyTimeEntry(entryDate: any) {
    await stTimeEntryApi.copyTimeEntry(this.entry.id!, entryDate);
    await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
    this.showDateChanger = false;
    notifySuccess('Zeiteintrag kopiert');
  }

  async moveTimeEntry(entryDate: any) {
    await stTimeEntryApi.moveTimeEntry(this.entry.id!, entryDate);
    await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
    this.showDateChanger = false;
    notifySuccess('Zeiteintrag verschoben');
  }

  async resumeStopwatch(entry: TimeEntryViewModel) {
    try {
      this.stopwatchLoading = true;
      await StopwatchStore.resumeStopwatch(entry.id!);

      await TimeEntryStore.LoadTimeEntryDays(TimeEntryStore.SelectedDate);
    } finally {
      this.stopwatchLoading = false;
    }
  }

  async loadData(){
    const date = DateTime.fromISO(this.entry.entryDate!);
    await TimeEntryStore.LoadTimeEntryDays(date);
  }

  async undoDeletion(id: number) {
    await stTimeEntryApi.undelete(id);

    await this.loadData();

    notifySuccess('Zeiteintrag wiederhergestellt.');
  }

  async deleteItem(id: number): Promise<DeleteResultModel> {
    try {
      this.deleteLoading = true;
      const resp = await stTimeEntryApi.delete(id, true);

      await this.loadData();

      notifyDeletion(async () => this.undoDeletion(id));

      return resp;
    } finally {
      this.deleteLoading = false;
    }
  }
}
